import React, { useState, useEffect } from 'react';
import { GetRequest } from 'components/common';

const SettingsMenu = ( {activeItem, activeTab, setActiveItem, canPreviewPrintingAndDieCutting} ) => {

  const _setActiveItem = (event, item, tabKey = null) => {
    event.preventDefault();
    setCookie('quote_builder_default_settings_item', item, 365);
    setActiveItem(item, tabKey);
    fetchCounts();
  }

  const [counts, setCounts] = useState({});
  const [attributeCounts, setAttributeCounts] = useState({});

  const fetchCounts = () => {
    GetRequest({
      url: '/quote_builder_user_unit_price_counts',
      callback: (data) => {
        setCounts( { ...data.counts } );
        setAttributeCounts( { ...data.attribute_counts } );
      }
    })
  };

  useEffect(() => {
    document.addEventListener('quote_builder.user_unit_price_deleted', fetchCounts);
    document.addEventListener('quote_builder.user_unit_price_saved', fetchCounts);
    return () => {
      document.removeEventListener('quote_builder.user_unit_price_deleted', fetchCounts);
      document.removeEventListener('quote_builder.user_unit_price_saved', fetchCounts);
    }
  }, []);

  useEffect(fetchCounts, []);

  const countFor = (key) => {
    if(counts[key] == 0 || counts[key] == undefined ) { return '' }
    return `(${counts[key]})`;
  }

  // Attribute counts live in a separate namespace from unit-price counts (a few
  // keys exist in both), so machine lines read from here.
  const attributeCountFor = (key) => {
    if(attributeCounts[key] == 0 || attributeCounts[key] == undefined ) { return '' }
    return `(${attributeCounts[key]})`;
  }

  // A machine section shows two lines: the machines themselves (the machine
  // attributes) and their unit prices, each opening its own tab. The machines tab
  // key equals the section key (e.g. printing_machine); the unit-prices tab has no
  // key, so it's opened with a null tab.
  const machineMenuItems = (key, machinesLabel, unitPricesLabel) => {
    const machinesTab = key;
    const onSection = activeItem == key;
    // The unit-prices line owns tab 0 (activeTab null); the machines line anchors
    // every other tab (the machines tab plus any extra attribute tabs, e.g.
    // guillotine's material/by-unit tabs), so the section always shows a highlight.
    const unitPricesActive = onSection && !activeTab;
    const machinesActive = onSection && !!activeTab;
    return <>
      <li key={`${key}_unit_prices`} className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, key, null) } className={unitPricesActive ? 'selected-section menuLink' : 'menuLink' }>
          {t(unitPricesLabel)} {countFor(key)}
        </a>
      </li>
      <li key={`${key}_machines`} className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, key, machinesTab) } className={machinesActive ? 'selected-section menuLink' : 'menuLink' }>
          {t(machinesLabel)} {attributeCountFor(machinesTab)}
        </a>
      </li>
    </>
  }

  if(activeItem != undefined && isMobile()) {
    return;
  }

  return(
  <div className="leftMarg15">
    <div className="promo-text-blog"> <i className="fa fa-cubes"></i> {t('quote_builder.materials')} </div>
    <ul className="blog-category">
      <li key="carton_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'carton_material') } className={`${activeItem == 'carton_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_material_cartons')} {countFor('carton_material')}
        </a>
      </li>

      <li key="corrugated_cardboard_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'corrugated_cardboard_material') } className={`${activeItem == 'corrugated_cardboard_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_material_corrugated_cardboards')} {countFor('corrugated_cardboard_material')}
        </a>
      </li>

      <li key="hard_cardboard_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'hard_cardboard_material') } className={`${activeItem == 'hard_cardboard_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_material_hard_cardboards')} {countFor('hard_cardboard_material')}
        </a>
      </li>

      <li key="coating_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'coating_material') } className={`${activeItem == 'coating_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_material_coating')} {countFor('coating_material')}
        </a></li>

      <li key="pvc_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'pvc_material') } className={`${activeItem == 'pvc_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_material_pvc')} {countFor('pvc_material')}
        </a></li>
    </ul>

    <div className="promo-text-blog"> <i className="fa fa-print"></i> {t('quote_builder.menu_print')} </div>
    <ul className="blog-category">
      {machineMenuItems('printing_machine', 'quote_builder.menu_printing_machines', 'quote_builder.printing_machine_unit_prices')}
    </ul>

    {canPreviewPrintingAndDieCutting &&
      <>
        <div className="promo-text-blog"> <i className="fa fa-print"></i> <i className="fa fa-scissors"></i> {t('quote_builder.menu_printing_and_die_cutting')} </div>
        <ul className="blog-category">
          {machineMenuItems('printing_and_die_cutting_machine', 'quote_builder.menu_printing_and_die_cutting_machines', 'quote_builder.printing_and_die_cutting_machine_unit_prices')}
        </ul>
      </>
    }

    <div className="promo-text-blog"> <i className="fa fa-scissors"></i> {t('quote_builder.menu_cutting')} </div>
    <ul className="blog-category">
      {machineMenuItems('die_cutting_machine', 'quote_builder.menu_die_cutting_machines', 'quote_builder.die_cutting_machine_unit_prices')}
      <li key="metal_strip" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'metal_strip') } className={`${activeItem == 'metal_strip' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.metal_strip_unit_prices')} {countFor('metal_strip')}
          </a> </li>
      <li key="cutting_board" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'cutting_board') } className={`${activeItem == 'cutting_board' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.cutting_board_unit_prices')} {countFor('cutting_board')}
        </a> </li>
    </ul>

    <div className="promo-text-blog"> <i className="fa fa-crop"></i> {t('quote_builder.guillotine_cutting')} </div>
    <ul className="blog-category">
      {machineMenuItems('guillotine_machine', 'quote_builder.menu_guillotine_machines', 'quote_builder.guillotine_machine_unit_prices')}
    </ul>

    <div className="promo-text-blog"> <i className="fa fa-square-o"></i> {t('quote_builder.menu_cellophane')} </div>
    <ul className="blog-category">
      <li key="cellophane_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'cellophane_material') } className={`${activeItem == 'cellophane_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_materials')} {countFor('cellophane_material')}
          </a> </li>
      <li key="cellophane_machine" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'cellophane_machine') } className={`${activeItem == 'cellophane_machine' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_machines')} {countFor('cellophane_machine')}
        </a> </li>
    </ul>

    <div className="promo-text-blog"> <i className="fa fa-link"></i> {t('quote_builder.glueing')} </div>
    <ul className="blog-category">
      <li key="glueing_machine" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'glueing_machine') } className={`${activeItem == 'glueing_machine' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.glueing_machines')} {countFor('glueing_machine')}
        </a> </li>
      <li key="glueing_manual_labor" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'glueing_manual_labor') } className={`${activeItem == 'glueing_manual_labor' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.glueing_manual_labor')} {countFor('glueing_manual_labor')}
        </a> </li>
      <li key="glueing_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'glueing_material') } className={`${activeItem == 'glueing_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.glueing_materials')} {countFor('glueing_material')}
        </a> </li>
    </ul>

    <div className="promo-text-blog"> <i className="fa fa-files-o"></i> {t('quote_builder.lamination')} </div>
    <ul className="blog-category">
      <li key="lamination_machine" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'lamination_machine') } className={`${activeItem == 'lamination_machine' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.lamination_machines')} {countFor('lamination_machine')}
        </a> </li>
      <li key="lamination_manual_labor" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'lamination_manual_labor') } className={`${activeItem == 'lamination_manual_labor' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.lamination_manual_labor')} {countFor('lamination_manual_labor')}
        </a> </li>
    </ul>

    <div className="promo-text-blog"> <i className="fa fa-fire"></i> {t('quote_builder.menu_hot_stamping')} </div>
    <ul className="blog-category">
      <li key="hot_stamping_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'hot_stamping_material') } className={`${activeItem == 'hot_stamping_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_materials')} {countFor('hot_stamping_material')}
        </a> </li>
      <li key="hot_stamping_printing_block" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'hot_stamping_printing_block') } className={`${activeItem == 'hot_stamping_printing_block' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_printing_blocks')} {countFor('hot_stamping_printing_block')}
        </a></li>
      <li key="hot_stamping_machine" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'hot_stamping_machine') } className={`${activeItem == 'hot_stamping_machine' ? 'selected-section menuLink' : 'menuLink' }`} >
        {t('quote_builder.menu_machines')} {countFor('hot_stamping_machine')}
        </a></li>
    </ul>

    <div className="promo-text-blog"> <i className="fa fa-magnet"></i> {t('quote_builder.menu_magnet')} </div>
    <ul className="blog-category">
      <li key="magnet_material" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'magnet_material') } className={`${activeItem == 'magnet_material' ? 'selected-section menuLink' : 'menuLink' }`} >
          {t('quote_builder.menu_magnets')} {countFor('magnet_material')}
        </a> </li>
    </ul>

    <div className="promo-text-blog"> <i className="fa fa-paint-brush"></i> {t('quote_builder.menu_coating_labour')} </div>
    <ul className="blog-category">
      <li key="coating_machine" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(e, 'coating_machine') } className={`${activeItem == 'coating_machine' ? 'selected-section menuLink' : 'menuLink' }`} >
        {t('quote_builder.coating_machines')} {countFor('coating_machine')}
        </a> </li>
      <li key="coating_manual_labor" className="pricing_menu"> <i className="fa fa-angle-right"></i>
        <a href="#" onClick={(e) => _setActiveItem(event, 'coating_manual_labor') } className={`${activeItem == 'coating_labour' ? 'selected-section menuLink' : 'menuLink' }`} >
        {t('quote_builder.coating_manual_labor')} {countFor('coating_manual_labor')}
        </a> </li>
    </ul>

    <div style={{ height: '60px' }}></div>

  </div>
  )
}

export default SettingsMenu;